import React, { useState } from 'react';
import { API_URL } from "../config/API_URLS.tsx";
import { authenticatedFetch } from "../auth/RequestSigner.tsx";

const RegistrationFormTicket = () => {
    const userDocument = localStorage.getItem('userDocument');
    const [vehiclePhoto, setVehiclePhoto] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({       
        document: userDocument,
        vehicle_type: '',
        placa: '',
        numero_marco:'',
        date: '',
        description: '',
        photo: '',
        status: '1'
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleVehiclePhoto = (e) => {
      const selectedImage = e.target.files[0];
      setVehiclePhoto(selectedImage);
      sendImageToS3Vehicle(selectedImage);
    };

    const sendImageToS3Vehicle = async (image) => {
      try {
        const formData2 = new FormData();
        formData2.append('image', image);        

        const response = await authenticatedFetch(`${API_URL}/v1/upload_img_s3`, {
          method: 'POST',        
          body: formData2
        });

        if (!response.ok) {
          throw new Error('Error en la solicitud');
        }

        const data = await response.json();
        setFormData({ ...formData, photo: data.url});

      } catch (error) {
        console.error('Error:', error);
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      setIsSubmitting(true);
      setSubmitError(null);
      setSubmitSuccess(false);
      try {
          const response = await authenticatedFetch(`${API_URL}/v1/tickets-registration`, {
              method: 'post',
              body: JSON.stringify(formData),
              headers: {
                  'Content-Type': 'application/json'
              }
          });
          if (!response.ok) {
              throw new Error('Error en la solicitud');
          }
          await response.json();
          setSubmitSuccess(true);
          setTimeout(() => {
            window.location.href = '/TicketsTable';
          }, 2000);
      } catch (error) {
          console.error('Error:', error);
          setSubmitError('Error al registrar el ticket');
      } finally {
          setIsSubmitting(false);
      }
    };

  return (
    <div className="flex-1 flex items-center justify-center lg:px-20  lg:py-20 px-4" data-testid="registration-form-ticket-container">
      <div className="bg-white flex flex-col justify-center rounded-xl shadow-lg p-8 w-full border border-gray-200" data-testid="registration-form-ticket-wrapper">
        <div className=" text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-1" data-testid="registration-form-ticket-title">
            Datos del Ticket
          </h2>
          <p className="text-gray-600">
            Complete el formulario para registrar un nuevo ticket
          </p>
        </div>
        
        <form className="space-y-4" onSubmit={handleSubmit} data-testid="registration-form-ticket-form">                  

          <div className="mb-4" data-testid="registration-form-ticket-vehicle-type-field">
            <label
              className="block text-gray-700 font-medium mb-2"
              htmlFor="vehicle_type"
              data-testid="registration-form-ticket-vehicle-type-label"
            >
              Tipo de vehículo
            </label>
            <select 
              id="vehicle_type"
              name="vehicle_type"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"            
              onChange={handleInputChange}
              data-testid="registration-form-ticket-vehicle-type-select"
              required
            >
              <option value="">Seleccione un tipo</option>
              <option value="Motocicleta">Motocicleta</option>
              <option value="Bicicleta">Bicicleta</option>              
            </select>
          </div>

          {formData.vehicle_type === "Motocicleta" && (
            <div className="mb-4">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="placa"
              >
                Número de placa
              </label>
              <input
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                type="text"
                id="placa"
                name="placa"
                placeholder="ABC-12A"
                value={formData.placa}
                onChange={handleInputChange}
                required
              />
            </div>
          )}       
          {formData.vehicle_type === "Bicicleta" && (
            <div className="mb-4">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="numero_marco"
              >
                Número de marco
              </label>
              <input
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
                type="text"
                id="numero_marco"
                name="numero_marco"
                placeholder="SN00AA1234BB"
                value={formData.numero_marco}
                onChange={handleInputChange}
                required
              />
            </div>
          )}

          {/*<div className="mb-4">*/}
          {/*  <label*/}
          {/*    className="block text-gray-700 font-medium mb-2"*/}
          {/*    htmlFor="date"*/}
          {/*  >*/}
          {/*    Fecha*/}
          {/*  </label>*/}
          {/*  <input*/}
          {/*    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"*/}
          {/*    type="date"*/}
          {/*    id="date"*/}
          {/*    name="date"*/}
          {/*    placeholder="2022-12-31"*/}
          {/*    value={formData.date}*/}
          {/*    onChange={handleInputChange}*/}
          {/*    required*/}
          {/*  />*/}
          {/*</div>*/}

          <div className="mb-4" data-testid="registration-form-ticket-description-field">
            <label
              className="block text-gray-700 font-medium mb-2"
              htmlFor="description"
              data-testid="registration-form-ticket-description-label"
            >
              Descripción
            </label>
            <textarea
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all"
              id="description"
              name="description"
              placeholder="Descripción del ticket..."              
              value={formData.description}
              onChange={handleInputChange}
              rows="2"
              required
              data-testid="registration-form-ticket-description-textarea"
            />
          </div>
          
          <div className="mb-4" data-testid="registration-form-ticket-photo-field">
            <label
              className="block text-gray-700 font-medium mb-2"
              htmlFor="photo"
              data-testid="registration-form-ticket-photo-label"
            >
              Imagen
            </label>
            <div className="flex w-full items-center justify-center p-2 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-amber-500 transition-all" 
                data-testid="registration-form-ticket-photo-dropzone"
                onClick={() => document.getElementById('foto_carnet').click()}
            >
              <label className="w-full flex flex-col items-center cursor-pointer">
                <svg
                  className="w-10 h-10 text-amber-500 mb-2"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                </svg>
                <span className="text-gray-700 font-medium">Selecciona una imagen</span>
                <span className="text-xs text-gray-500 mt-1">PNG, JPG, JPEG</span>
                <input type="file" accept=".png,.jpg,.jpeg"
                id="foto_carnet"
                onChange={handleVehiclePhoto} 
                className="hidden"
                data-testid="registration-form-ticket-photo-input" />
              </label>
            </div>
          </div>
          
          {vehiclePhoto && (
            <div className="mb-6 p-2 border border-gray-200 rounded-lg" data-testid="registration-form-ticket-image-preview-container">
              <p className="text-center p-2 text-amber-600 font-medium mb-2">Imagen seleccionada:</p>
              <div className="rounded-lg overflow-hidden">
                <img 
                  src={URL.createObjectURL(vehiclePhoto)} 
                  alt="Imagen seleccionada" 
                  className="w-full object-cover" 
                  data-testid="registration-form-ticket-image-preview" 
                />
              </div>
            </div>
          )}
          
          <div className="flex items-center justify-between space-x-4 mt-6" data-testid="registration-form-ticket-buttons">
            <button
              type="button"
              onClick={() => window.history.back()}
              className="px-4 py-3 text-gray-700 bg-gray-100 font-medium rounded-lg shadow-sm hover:bg-gray-200 transition-all flex-1"
              data-testid="registration-form-ticket-cancel-button"
            >
              Cancelar
            </button>
            <button
              className="px-4 py-3 text-white font-medium rounded-lg shadow-md flex-1 relative overflow-hidden group"
              type="submit"
              disabled={isSubmitting}
              data-testid="registration-form-ticket-submit-button"
            >
              <div className="absolute inset-0 bg-gradient-to-t from-amber-300 to-amber-700 transition-transform duration-700 ease-in-out"></div>
              <div className="absolute inset-0 bg-gradient-to-b from-amber-300 to-amber-700 opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out"></div>
              <span className="relative z-10 text-gray-900">
                {isSubmitting ? (
                  <span className="flex items-center justify-center" data-testid="registration-form-ticket-submitting">
                    <svg className="animate-spin mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Enviando...
                  </span>
                ) : (
                  "Enviar Ticket"
                )}
              </span>
            </button>
          </div>
          
          {submitError && (
            <div className="bg-red-50 text-red-700 p-4 rounded-lg border border-red-200 mt-6" role="alert" data-testid="registration-form-ticket-error">
              <div className="flex">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                </svg>
                <span className="block">{submitError}</span>
              </div>
            </div>
          )}
          
          {submitSuccess && (
            <div className="bg-green-50 text-green-700 p-4 rounded-lg border border-green-200 mt-6" role="alert" data-testid="registration-form-ticket-success">
              <div className="flex">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="block">Ticket creado exitosamente</span>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export { RegistrationFormTicket };
